<template>
  <div class="menuoptions" :class="{ 'menuoptions--open': showSearchForm }">
    <div class="option">
      <button class="button" @click="$emit('clicked')" aria-label="Zum Seitenanfang">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill="none" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 23.25V.75M22.5 11.25L12 .75 1.5 11.25"/></svg>
      </button>
    </div>

    <div class="option flex">
      <div v-show="showSearchForm" class="flex items-center">

        <label
          class="block text-black font-bold mr-4"
          for="searchQueryInput">Suche: </label>
        <input id="searchQueryInput" ref="searchQueryInput" autocomplete="off" type="text" @input="updateSearchQuery" class="flex-grow mr-4 border border-green-heinz rounded-full py-2 px-4 outline-none" />
      </div>
      <button class="button flex-grow-0" @click="toggleSearchForm" :aria-label="!showSearchForm ? 'Suche' : 'Suche schließen'">
        <svg v-if="!showSearchForm" width="24" height="24" xmlns="http://www.w3.org/2000/svg" fill-rule="evenodd" clip-rule="evenodd"><path fill="none" stroke="currentColor" d="M15.853 16.56c-1.683 1.517-3.911 2.44-6.353 2.44-5.243 0-9.5-4.257-9.5-9.5s4.257-9.5 9.5-9.5 9.5 4.257 9.5 9.5c0 2.442-.923 4.67-2.44 6.353l7.44 7.44-.707.707-7.44-7.44zm-6.353-15.56c4.691 0 8.5 3.809 8.5 8.5s-3.809 8.5-8.5 8.5-8.5-3.809-8.5-8.5 3.809-8.5 8.5-8.5z"/></svg>
        <svg v-if="showSearchForm" width="20" height="20" viewBox="0 0 329.26933 329" xmlns="http://www.w3.org/2000/svg"><path  fill="currentColor" d="m194.800781 164.769531 128.210938-128.214843c8.34375-8.339844 8.34375-21.824219 0-30.164063-8.339844-8.339844-21.824219-8.339844-30.164063 0l-128.214844 128.214844-128.210937-128.214844c-8.34375-8.339844-21.824219-8.339844-30.164063 0-8.34375 8.339844-8.34375 21.824219 0 30.164063l128.210938 128.214843-128.210938 128.214844c-8.34375 8.339844-8.34375 21.824219 0 30.164063 4.15625 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921875-2.089844 15.082031-6.25l128.210937-128.214844 128.214844 128.214844c4.160156 4.160156 9.621094 6.25 15.082032 6.25 5.460937 0 10.921874-2.089844 15.082031-6.25 8.34375-8.339844 8.34375-21.824219 0-30.164063zm0 0"/></svg>
      </button>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapMutations } from 'vuex'

export default {
  name: 'MenuOptions',

  data () {
    return {
      showSearchForm: false
    }
  },

  computed: {
    ...mapGetters([
      'getSearchQuery'
    ])
  },

  created () {
    this.setSearchQuery('')
  },

  methods: {
    ...mapMutations([
      'setSearchQuery'
    ]),

    updateSearchQuery: function (e) {
      this.setSearchQuery(e.target.value)
    },

    toggleSearchForm: function (e) {
      e.preventDefault()

      this.setSearchQuery('')
      this.showSearchForm = !this.showSearchForm

      if (this.showSearchForm) {
        this.$nextTick(() => {
          this.$refs.searchQueryInput.focus()
        })
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MenuOptions.vue